import type {
  ReactionsApiResponse,
  ReactionsDataResponse,
  ReactionsListResponse,
  UserReactionsResponse,
  UserToken,
} from "@src/app/types/Reactions";

const API_BASE = "/_plat/api/reactions";

async function postJson<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(`${API_BASE}/${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  return (await res.json()) as T;
}

export async function fetchReactions(
  articleId: string,
): Promise<ReactionsDataResponse> {
  return postJson<ReactionsDataResponse>("get-reaction", { articleId });
}

export async function fetchReactionList(
  articleIds: string[],
): Promise<ReactionsListResponse> {
  const query = encodeURIComponent(articleIds.join(","));
  const res = await fetch(`${API_BASE}/get-reaction-list?articleId=${query}`);
  return (await res.json()) as ReactionsListResponse;
}

export async function fetchUserReaction(
  articleId: string,
  userToken: UserToken,
): Promise<UserReactionsResponse> {
  return postJson<UserReactionsResponse>("get-user-reaction", {
    articleId,
    userToken,
  });
}

export async function addReaction(
  articleId: string,
  reactId: string,
  userToken: UserToken,
): Promise<ReactionsApiResponse<ReactionsDataResponse>> {
  return postJson<ReactionsApiResponse<ReactionsDataResponse>>("user-reacts", {
    articleId,
    userToken,
    reactId,
  });
}

export async function deleteReaction(
  articleId: string,
  userToken: UserToken,
): Promise<ReactionsApiResponse<ReactionsDataResponse>> {
  return postJson<ReactionsApiResponse<ReactionsDataResponse>>(
    "delete-user-reacts",
    { articleId, userToken },
  );
}
